// Generated by ReScript, PLEASE EDIT WITH CARE


var fareEstimateResultDummyResponse = {
    "data": [
        {
            "id": 1,
            "attributes": {
                "slug": "bangalore",
                "show_callback": true,
                "createdAt": "2023-02-08T11:06:04.076Z",
                "updatedAt": "2023-02-08T11:06:05.503Z",
                "publishedAt": "2023-02-08T11:06:05.497Z",
                "callback_text": {
                    "id": 9,
                    "text": "We are here to help 🤝",
                    "sub_text": "Did not find what you were looking for?"
                },
                "vehicles_info": {
                    "data": [
                        {
                            "id": 3,
                            "attributes": {
                                "vehicle_name": "Pickup 8Ft",
                                "createdAt": "2023-02-08T10:54:33.379Z",
                                "updatedAt": "2023-02-08T10:54:34.087Z",
                                "publishedAt": "2023-02-08T10:54:34.084Z",
                                "vehicle_image": {
                                    "id": 94,
                                    "alt_text": "lorem",
                                    "src_path": {
                                        "data": {
                                            "id": 139,
                                            "attributes": {
                                                "name": "truck-dimensions.png",
                                                "alternativeText": "truck-dimensions.png",
                                                "caption": "truck-dimensions.png",
                                                "width": 113,
                                                "height": 70,
                                                "formats": null,
                                                "hash": "truck_dimensions_66d564662d",
                                                "ext": ".png",
                                                "mime": "image/png",
                                                "size": 0.98,
                                                "url": "https://strapi-media-library-staging.s3.ap-southeast-1.amazonaws.com/truck_dimensions_66d564662d.png",
                                                "previewUrl": null,
                                                "provider": "aws-s3",
                                                "provider_metadata": null,
                                                "createdAt": "2023-02-08T10:53:27.722Z",
                                                "updatedAt": "2023-02-08T10:53:27.722Z"
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        {
                            "id": 2,
                            "attributes": {
                                "vehicle_name": "Tata 407",
                                "createdAt": "2023-02-08T10:54:08.703Z",
                                "updatedAt": "2023-02-08T10:54:09.187Z",
                                "publishedAt": "2023-02-08T10:54:09.184Z",
                                "vehicle_image": {
                                    "id": 93,
                                    "alt_text": "lorem",
                                    "src_path": {
                                        "data": {
                                            "id": 139,
                                            "attributes": {
                                                "name": "truck-dimensions.png",
                                                "alternativeText": "truck-dimensions.png",
                                                "caption": "truck-dimensions.png",
                                                "width": 113,
                                                "height": 70,
                                                "formats": null,
                                                "hash": "truck_dimensions_66d564662d",
                                                "ext": ".png",
                                                "mime": "image/png",
                                                "size": 0.98,
                                                "url": "https://strapi-media-library-staging.s3.ap-southeast-1.amazonaws.com/truck_dimensions_66d564662d.png",
                                                "previewUrl": null,
                                                "provider": "aws-s3",
                                                "provider_metadata": null,
                                                "createdAt": "2023-02-08T10:53:27.722Z",
                                                "updatedAt": "2023-02-08T10:53:27.722Z"
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        {
                            "id": 1,
                            "attributes": {
                                "vehicle_name": "Tata Ace",
                                "createdAt": "2023-02-08T10:53:37.394Z",
                                "updatedAt": "2023-02-08T10:53:39.029Z",
                                "publishedAt": "2023-02-08T10:53:39.022Z",
                                "vehicle_image": {
                                    "id": 92,
                                    "alt_text": "lorem",
                                    "src_path": {
                                        "data": {
                                            "id": 139,
                                            "attributes": {
                                                "name": "truck-dimensions.png",
                                                "alternativeText": "truck-dimensions.png",
                                                "caption": "truck-dimensions.png",
                                                "width": 113,
                                                "height": 70,
                                                "formats": null,
                                                "hash": "truck_dimensions_66d564662d",
                                                "ext": ".png",
                                                "mime": "image/png",
                                                "size": 0.98,
                                                "url": "https://strapi-media-library-staging.s3.ap-southeast-1.amazonaws.com/truck_dimensions_66d564662d.png",
                                                "previewUrl": null,
                                                "provider": "aws-s3",
                                                "provider_metadata": null,
                                                "createdAt": "2023-02-08T10:53:27.722Z",
                                                "updatedAt": "2023-02-08T10:53:27.722Z"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    ]
                },
                "meta": {
                    "id": 13,
                    "title": "Fare Estimate - Trucks",
                    "description": "Lorem"
                }
            }
        },
        {
            "id": 2,
            "attributes": {
                "slug": "mumbai",
                "show_callback": true,
                "createdAt": "2023-02-08T11:06:25.579Z",
                "updatedAt": "2023-02-08T11:06:26.396Z",
                "publishedAt": "2023-02-08T11:06:26.392Z",
                "callback_text": {
                    "id": 10,
                    "text": "We are here to help ",
                    "sub_text": "Did not find what you were looking for??"
                },
                "vehicles_info": {
                    "data": [
                        {
                            "id": 2,
                            "attributes": {
                                "vehicle_name": "Tata 407",
                                "createdAt": "2023-02-08T10:54:08.703Z",
                                "updatedAt": "2023-02-08T10:54:09.187Z",
                                "publishedAt": "2023-02-08T10:54:09.184Z",
                                "vehicle_image": {
                                    "id": 93,
                                    "alt_text": "lorem",
                                    "src_path": {
                                        "data": {
                                            "id": 139,
                                            "attributes": {
                                                "name": "truck-dimensions.png",
                                                "alternativeText": "truck-dimensions.png",
                                                "caption": "truck-dimensions.png",
                                                "width": 113,
                                                "height": 70,
                                                "formats": null,
                                                "hash": "truck_dimensions_66d564662d",
                                                "ext": ".png",
                                                "mime": "image/png",
                                                "size": 0.98,
                                                "url": "https://strapi-media-library-staging.s3.ap-southeast-1.amazonaws.com/truck_dimensions_66d564662d.png",
                                                "previewUrl": null,
                                                "provider": "aws-s3",
                                                "provider_metadata": null,
                                                "createdAt": "2023-02-08T10:53:27.722Z",
                                                "updatedAt": "2023-02-08T10:53:27.722Z"
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        {
                            "id": 3,
                            "attributes": {
                                "vehicle_name": "Pickup 8Ft",
                                "createdAt": "2023-02-08T10:54:33.379Z",
                                "updatedAt": "2023-02-08T10:54:34.087Z",
                                "publishedAt": "2023-02-08T10:54:34.084Z",
                                "vehicle_image": {
                                    "id": 94,
                                    "alt_text": "lorem",
                                    "src_path": {
                                        "data": {
                                            "id": 139,
                                            "attributes": {
                                                "name": "truck-dimensions.png",
                                                "alternativeText": "truck-dimensions.png",
                                                "caption": "truck-dimensions.png",
                                                "width": 113,
                                                "height": 70,
                                                "formats": null,
                                                "hash": "truck_dimensions_66d564662d",
                                                "ext": ".png",
                                                "mime": "image/png",
                                                "size": 0.98,
                                                "url": "https://strapi-media-library-staging.s3.ap-southeast-1.amazonaws.com/truck_dimensions_66d564662d.png",
                                                "previewUrl": null,
                                                "provider": "aws-s3",
                                                "provider_metadata": null,
                                                "createdAt": "2023-02-08T10:53:27.722Z",
                                                "updatedAt": "2023-02-08T10:53:27.722Z"
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        {
                            "id": 1,
                            "attributes": {
                                "vehicle_name": "Tata Ace",
                                "createdAt": "2023-02-08T10:53:37.394Z",
                                "updatedAt": "2023-02-08T10:53:39.029Z",
                                "publishedAt": "2023-02-08T10:53:39.022Z",
                                "vehicle_image": {
                                    "id": 92,
                                    "alt_text": "lorem",
                                    "src_path": {
                                        "data": {
                                            "id": 139,
                                            "attributes": {
                                                "name": "truck-dimensions.png",
                                                "alternativeText": "truck-dimensions.png",
                                                "caption": "truck-dimensions.png",
                                                "width": 113,
                                                "height": 70,
                                                "formats": null,
                                                "hash": "truck_dimensions_66d564662d",
                                                "ext": ".png",
                                                "mime": "image/png",
                                                "size": 0.98,
                                                "url": "https://strapi-media-library-staging.s3.ap-southeast-1.amazonaws.com/truck_dimensions_66d564662d.png",
                                                "previewUrl": null,
                                                "provider": "aws-s3",
                                                "provider_metadata": null,
                                                "createdAt": "2023-02-08T10:53:27.722Z",
                                                "updatedAt": "2023-02-08T10:53:27.722Z"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    ]
                },
                "meta": {
                    "id": 14,
                    "title": "Fare Estimate - Trucks",
                    "description": "Lorem"
                }
            }
        },
        {
            "id": 3,
            "attributes": {
                "slug": "jaipur",
                "show_callback": false,
                "createdAt": "2023-02-08T11:07:00.155Z",
                "updatedAt": "2023-02-08T11:07:01.529Z",
                "publishedAt": "2023-02-08T11:07:01.517Z",
                "callback_text": {
                    "id": 11,
                    "text": "We are here to help!",
                    "sub_text": "Did not find what you were looking for?"
                },
                "vehicles_info": {
                    "data": [
                        {
                            "id": 2,
                            "attributes": {
                                "vehicle_name": "Tata 407",
                                "createdAt": "2023-02-08T10:54:08.703Z",
                                "updatedAt": "2023-02-08T10:54:09.187Z",
                                "publishedAt": "2023-02-08T10:54:09.184Z",
                                "vehicle_image": {
                                    "id": 93,
                                    "alt_text": "lorem",
                                    "src_path": {
                                        "data": {
                                            "id": 139,
                                            "attributes": {
                                                "name": "truck-dimensions.png",
                                                "alternativeText": "truck-dimensions.png",
                                                "caption": "truck-dimensions.png",
                                                "width": 113,
                                                "height": 70,
                                                "formats": null,
                                                "hash": "truck_dimensions_66d564662d",
                                                "ext": ".png",
                                                "mime": "image/png",
                                                "size": 0.98,
                                                "url": "https://strapi-media-library-staging.s3.ap-southeast-1.amazonaws.com/truck_dimensions_66d564662d.png",
                                                "previewUrl": null,
                                                "provider": "aws-s3",
                                                "provider_metadata": null,
                                                "createdAt": "2023-02-08T10:53:27.722Z",
                                                "updatedAt": "2023-02-08T10:53:27.722Z"
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        {
                            "id": 3,
                            "attributes": {
                                "vehicle_name": "Pickup 8Ft",
                                "createdAt": "2023-02-08T10:54:33.379Z",
                                "updatedAt": "2023-02-08T10:54:34.087Z",
                                "publishedAt": "2023-02-08T10:54:34.084Z",
                                "vehicle_image": {
                                    "id": 94,
                                    "alt_text": "lorem",
                                    "src_path": {
                                        "data": {
                                            "id": 139,
                                            "attributes": {
                                                "name": "truck-dimensions.png",
                                                "alternativeText": "truck-dimensions.png",
                                                "caption": "truck-dimensions.png",
                                                "width": 113,
                                                "height": 70,
                                                "formats": null,
                                                "hash": "truck_dimensions_66d564662d",
                                                "ext": ".png",
                                                "mime": "image/png",
                                                "size": 0.98,
                                                "url": "https://strapi-media-library-staging.s3.ap-southeast-1.amazonaws.com/truck_dimensions_66d564662d.png",
                                                "previewUrl": null,
                                                "provider": "aws-s3",
                                                "provider_metadata": null,
                                                "createdAt": "2023-02-08T10:53:27.722Z",
                                                "updatedAt": "2023-02-08T10:53:27.722Z"
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        {
                            "id": 1,
                            "attributes": {
                                "vehicle_name": "Tata Ace",
                                "createdAt": "2023-02-08T10:53:37.394Z",
                                "updatedAt": "2023-02-08T10:53:39.029Z",
                                "publishedAt": "2023-02-08T10:53:39.022Z",
                                "vehicle_image": {
                                    "id": 92,
                                    "alt_text": "lorem",
                                    "src_path": {
                                        "data": {
                                            "id": 139,
                                            "attributes": {
                                                "name": "truck-dimensions.png",
                                                "alternativeText": "truck-dimensions.png",
                                                "caption": "truck-dimensions.png",
                                                "width": 113,
                                                "height": 70,
                                                "formats": null,
                                                "hash": "truck_dimensions_66d564662d",
                                                "ext": ".png",
                                                "mime": "image/png",
                                                "size": 0.98,
                                                "url": "https://strapi-media-library-staging.s3.ap-southeast-1.amazonaws.com/truck_dimensions_66d564662d.png",
                                                "previewUrl": null,
                                                "provider": "aws-s3",
                                                "provider_metadata": null,
                                                "createdAt": "2023-02-08T10:53:27.722Z",
                                                "updatedAt": "2023-02-08T10:53:27.722Z"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    ]
                },
                "meta": {
                    "id": 15,
                    "title": "Fare Estimate - Trucks",
                    "description": "Lorem Ipsum"
                }
            }
        }
    ],
    "meta": {
        "pagination": {
            "page": 1,
            "pageSize": 25,
            "pageCount": 1,
            "total": 3
        }
    }
};

var homeOmsDummyResponse = {
    "callback_request_response": {
        "result": true,
        "prev_callback_req_id_present": true,
        "callback_request_id": "REQ214913702",
        "is_existing_cust": true,
        "brand": "porter"
    },
    "vehicles": [
        {
            "display_name": "Tata 407",
            "vehicle_id": 2,
            "vehicle_type": "Tata 407",
            "image_alt_text": "tata_407",
            "image_url": "https://oms-staging-1.porter.in//assets/website_revamp/large_vehicles/tata_407-b968c07406c8b63fca431ef8ea2152caf5272b0013502a73d2390289f1138505.png",
            "capacity_display": "2500 kg",
            "size_display": "9ft x 5.5ft x 6ft",
            "base_fare_display": "INR 586",
            "size": {
                "length": {
                    "value": "9",
                    "unit": "ft"
                },
                "breadth": {
                    "value": "5.5",
                    "unit": "ft"
                },
                "height": {
                    "value": "6",
                    "unit": "ft"
                }
            },
            "base_fare": {
                "value": "586",
                "currency": "rupee"
            }
        },
        {
            "display_name": "3 Wheeler",
            "vehicle_id": 3,
            "vehicle_type": "3 Wheeler",
            "image_alt_text": "3_wheeler",
            "image_url": "https://oms-staging-1.porter.in//assets/website_revamp/large_vehicles/3_wheeler-022fc2284832545607afeea8be6e567e0d2e99ff2e4e035e4f66374b22fa92db.png",
            "capacity_display": "1 ton",
            "size_display": "7.2ft x 4.9ft x 4.9ft",
            "base_fare_display": "INR 375",
            "size": {
                "length": {
                    "value": "7.2",
                    "unit": "ft"
                },
                "breadth": {
                    "value": "4.9",
                    "unit": "ft"
                },
                "height": {
                    "value": "4.9",
                    "unit": "ft"
                }
            },
            "base_fare": {
                "value": "375",
                "currency": "rupee"
            }
        },
        {
            "display_name": "Tata Ace mini",
            "vehicle_id": 11,
            "vehicle_type": "Tata Ace",
            "image_alt_text": "tata_ace_mini",
            "image_url": "https://oms-staging-1.porter.in//assets/website_revamp/large_vehicles/tata_ace_closed-e92a36b3508e6e3b1804fd2015adbfb6c948bc35afab36699440785ed83b5b24.png",
            "capacity_display": "750 kg",
            "size_display": "7ft x 4.5ft x 6ft",
            "base_fare_display": "INR 3128",
            "size": {
                "length": {
                    "value": "7",
                    "unit": "ft"
                },
                "breadth": {
                    "value": "4.5",
                    "unit": "ft"
                },
                "height": {
                    "value": "6",
                    "unit": "ft"
                }
            },
            "base_fare": {
                "value": "3128",
                "currency": "rupee"
            }
        },
        {
            "display_name": "Pickup 8ft",
            "vehicle_type": "Pickup / 8ft",
            "vehicle_id": 4,
            "image_alt_text": "pickup_8ft",
            "image_url": "https://oms-staging-1.porter.in//assets/website_revamp/large_vehicles/pickup_8ft-5daaf8cf8ab115b87e6ead485301f032ae8722c594537af99b45732905087eed.png",
            "capacity_display": "1250 kg",
            "size_display": "8ft x 4.5ft x 5.5ft",
            "base_fare_display": "INR 102",
            "size": {
                "length": {
                    "value": "8",
                    "unit": "ft"
                },
                "breadth": {
                    "value": "4.5",
                    "unit": "ft"
                },
                "height": {
                    "value": "5.5",
                    "unit": "ft"
                }
            },
            "base_fare": {
                "value": "102",
                "currency": "rupee"
            }
        },
        {
            "display_name": "Pickup 8ft ( id 9)",
            "vehicle_type": "Pickup / Dost / Super Ace / 8ft",
            "vehicle_id": 5,
            "image_alt_text": "pickup_8ft_(_id_9)",
            "image_url": "https://oms-staging-1.porter.in//assets/website_revamp/large_vehicles/tata_ace_closed-e92a36b3508e6e3b1804fd2015adbfb6c948bc35afab36699440785ed83b5b24.png",
            "capacity_display": "1250 kg",
            "size_display": "8ft x 4.5ft x 5.5ft",
            "base_fare_display": "INR 389",
            "size": {
                "length": {
                    "value": "8",
                    "unit": "ft"
                },
                "breadth": {
                    "value": "4.5",
                    "unit": "ft"
                },
                "height": {
                    "value": "5.5",
                    "unit": "ft"
                }
            },
            "base_fare": {
                "value": "389",
                "currency": "rupee"
            }
        },
        {
            "display_name": "Ace (Helper + 1 Labour)",
            "vehicle_type": "Ace Helper + 1 Labour",
            "vehicle_id": 6,
            "image_alt_text": "ace_(helper_+_1_labour)",
            "image_url": "https://oms-staging-1.porter.in//assets/website_revamp/large_vehicles/tata_ace_closed-e92a36b3508e6e3b1804fd2015adbfb6c948bc35afab36699440785ed83b5b24.png",
            "capacity_display": "750 kg",
            "size_display": "7ft x 4.5ft x 5.5ft",
            "base_fare_display": "INR 731",
            "size": {
                "length": {
                    "value": "7",
                    "unit": "ft"
                },
                "breadth": {
                    "value": "4.5",
                    "unit": "ft"
                },
                "height": {
                    "value": "5.5",
                    "unit": "ft"
                }
            },
            "base_fare": {
                "value": "731",
                "currency": "rupee"
            }
        },
        {
            "display_name": "Canter 14ft",
            "vehicle_type": "Tata 407 14ft",
            "vehicle_id": 7,
            "image_alt_text": "canter_14ft",
            "image_url": "https://oms-staging-1.porter.in//assets/website_revamp/large_vehicles/canter_14ft-e90b94fb3bffacd6d30fa80c63256dfb38033266674f2f5f0739d6c4de2fe5a6.png",
            "capacity_display": "3500 kg",
            "size_display": "14ft x 6ft x 6ft",
            "base_fare_display": "INR 244",
            "size": {
                "length": {
                    "value": "14",
                    "unit": "ft"
                },
                "breadth": {
                    "value": "6",
                    "unit": "ft"
                },
                "height": {
                    "value": "6",
                    "unit": "ft"
                }
            },
            "base_fare": {
                "value": "244",
                "currency": "rupee"
            }
        },
        {
            "display_name": "2 wheeler test",
            "vehicle_type": "2 Wheeler",
            "vehicle_id": 8,
            "image_alt_text": "2_wheeler_test",
            "image_url": "https://oms-staging-1.porter.in//assets/website_revamp/large_vehicles/tata_ace_closed-e92a36b3508e6e3b1804fd2015adbfb6c948bc35afab36699440785ed83b5b24.png",
            "capacity_display": "20 Kg",
            "size_display": "40cm * 40cm * 40 cm",
            "base_fare_display": "INR 84",
            "size": {},
            "base_fare": {
                "value": "84",
                "currency": "rupee"
            }
        }
    ]
};

var FareEstimateResultRepo = {
  fareEstimateResultDummyResponse: fareEstimateResultDummyResponse,
  homeOmsDummyResponse: homeOmsDummyResponse
};

var dummyCheckCustomerExist = {
  "exists": false
//   "exists": true
};

export {
  FareEstimateResultRepo ,
  dummyCheckCustomerExist ,
}
/* No side effect */
